import styled from "styled-components";

import * as Types from "Types";

import { devices } from "images";

const Wrap = styled.div<Types.Default>`
   position: relative;
   width: 1000px;
   max-width: 100%;
   padding-top: 54.75%;
   ${({ css }) => css}
`;

const ImgDevices = styled.img`
   position: absolute;
   top: 0;
   left: 19%;
   width: 73%;
`;

export default function Devices(props: Types.Default) {
   return (
      <Wrap {...props}>
         <ImgDevices src={devices} alt="컴퓨터와 휴대폰" />
      </Wrap>
   );
}
